module.exports = {
  missingRequired: 'Bittet um Eingabe in allen Pflichtfeldern!',
  missingUsername: 'Bitte Benutzername eingeben.',
  missingPassword: 'Bitte Kennwort eingeben.',
  noContacts: 'Keine Kontakte gefunden die gewählte Suchkriterien erfüllen.',
  contactNoAddresses: 'Dieser Kontakt verfügt über keine Adresse.',
  deleteContact: 'Kontakt löschen?',
  emptyField: 'Bitte Werte in allen Feldern einfügen.',
  priceNumber: 'Preis muss eine Zahl sein.',
  vatNumber: 'MwSt. muss eine Zahl sein.',
  selectOne: 'Bitte mindestens einen Artikel wählen.',
  enterOne: 'Bitte mindestens ein Suchkriterium wählen.',
  outOfBusinessHours: 'Aktuelle Zeit ist außerhalb der Geschäftszeiten',
  outOfYourHours: 'Gewählte Zeit ist außerhalb der Geschäftszeiten.',
  cantReachServer: 'Server nicht erreichbar für Summenberechnung. Gesamtpreis kann inkorrekt gerundet sein.',
  receiptSearch: 'Bittet Datum und Belegtyp oder Rechnungsnummer oder Belegnummer eingeben.',
  noReceipts: 'Keine Belege gefunden',
  noNotifications: 'Keine Benachrichtigungen.',
  noPayments: 'Keine Zahlungen gefunden.',
  noTerminals: 'Keine verfügbaren Terminals gefunden. Bitte prüfen ob Terminal im Leerlauf und keine Aktion auf dem Bildschirm angezeigt wird , dass die Netzwerk und Stromkabeln ordnungsgemäß angeschloßen und es nicht im Einzelmodus ist. Falls dies keine Lösung ermöglichen, bitte um Neustart des Terminals und - falls auch dies keine LÖsung ist - Kontakt mit dem Support.',
  onlyOpenPayments: 'Nur offene Zahlungen können gestartet werden.',
  calculationFailed: 'Rückgeldberechnung fehlgeschlagen. Offline Berechnung',
  notSameTotals: 'Summe der Zahlung ist nicht deckungsgleich mit Summe der Artikel. Bitte um Kontrolle der Zahlungen.',
  contactForDelivery: 'Bitte für Lieferung Kontakt wählen.',
  checkPrinter: 'Prüfung nach Standarddrucker des Benutzers fehlgeschlagen.',
  changeTable: 'Änderung der Tischnutzung fehlgeschlagen.',
  orderNotLocked: 'Auftragt ist nicht mehr gesperrt und Zahlung kann nicht fortgeführt werden.',
  tableNoOrders: 'Gewählte Tabelle beinhaltet keine Aufträge',
  failedToFetchTables: 'Suche nach offenen Tischaufträgen fehlgeschlagen',
  fetchTables: 'Suche nach Tischen fehlgeschlagen',
  fetchTableComments: 'Suche nach Tischkommentaren fehlgeschlagen.',
  markComment: 'Kennzeichnung des Kommentars als gelesen fehlgeschlagen.',
  fetchCategories: 'Suche nach Tischkategorien fehlgeschlagen.',
  noCatForTables: 'Keine Tischkategorien gefunden.',
  unpaidBill: 'Erstellung von Zwischenliste fehlgeschlagen',
  fetchPrinters: 'Suche nach Druckern fehlgeschlagen',
  checkDefaultPrinter: 'Prüfung nach Standarddrucker fehlgeschlagen',
  enterHost: 'Bitte Host eingeben.',
  enterKey: 'Bitte API Schlüssel eingeben.',
  noData: 'Keine Daten gefunden',
  printJobs: 'Suche nach Druckaufträgen fehlgeschlagen.',
  systemWarning: 'Diese Funktion kann ihre Arbeit und den Zustand des Systems gefährden; bitte nur auslösen falls ausdrücklich vom Support angewiesen. Bitte um Bestätigung dass die möglichen Konsequenzen verstanden wurden und die Aktion forgesetzt werden soll.',
  companySettings: 'Such nach Firmeneinstellungen fehlgeschlagen. Bitte erneut anmelden.',
  userRoles: 'Suche nach Benutzerrollen fehlgeschlagen. Bitte erneut anmelden.',
  depUnavailable: 'Sicherheitseinrichtung ausgefallen',
  enterDate: 'Bitte sowohl von als auch bis Datum eingeben.',
  fromDate: 'Von Datum darf nicht hinter dem bis Datum liegen',
  fetchPayments: 'Suche nach offenen Zahlungen fehlgeschlagen',
  noReports: 'Keine Berichte verfügbar',
  exportData: 'Datenexport fehlgeschlagen.',
  ticketStatus: 'Prüfung des Ticket Statuses fehlgeschlagen',
  ticketProcessed: 'Anfrage wird bearbeitet: Ticket#:',
  ticketData: 'Download der Ticketdaten fehlgeschlagen',
  fetchTaxReports: 'Download der Steuerdaten Berichts fehlgeschlagen',
  fetchItemUsage: 'Download der Artikelverkauf Berichts fehlgeschlagen',
  atLeastOneItemInCart: 'Bitte zumindest einen Artikel in den Warenkorb legen.',
  mustSelectOrderType: 'Bitte Bestelltyp wählen.',
  addContactFirst: 'Bitte einen Kontakt für diesen Bestelltyp wählen.',
  couldntReachServer: '***Couldn\'t reach the server for calculating total. Total price might not be correct.',
  mainwaySuccess: '***Mainaway successful',
  failedBill: 'Fehler beim erstellen der Zwischenliste',
  failedPrinters: 'Fehler beim Lesen der Drucker',
  failedDefaultPrinter: 'Standarddrucker konnte nicht gelesen werden',
  cantEditOrder: 'Diese Bestellung kann nicht bearbeitet werden.',
  failedTableComments: '***Failed to fetch table comments.',
  notLocked: 'Bestellung ist entsperrt und kann bearbeitet werden.',
  munutesAgo: '***minute(s) ago. Please retry later.',
  anotherUserLocked: 'Bestellung wird bereits durch einen anderen Benutzer bearbeitet',
  tableState: 'Tischstatus konnte nicht geändert werden.',
  sizesVariants: 'Größe oder Variante sind nicht gewählt für diesen Artikel!',
  failedCastalog: 'Katalog konnte nicht gelesen werden',
  required: 'Pflichtfeld!',
  minNineChars: 'Mindestens 9 Zeichen!',
  galaxyAlreadyAdded: 'Die gewählte Galaxy Card wurde bereits hinzugefügt!',
  galaxyCanceled: '***Error in processing, all Galaxy Bookings canceled!',
  galaxyNotActive: 'Die gewählte Galaxy Card ist inaktiv, bitte eine andere Karte wählen. Status:',
  galaxyBalaceZero: 'Diese Galaxy Card hat 0 Guthaben, bitte andere Karte wählen.',
  galaxyItemType: 'Fehler: Galaxy Card Guthaben und reguläre Artikel dürfen nicht kombiniert werden.',
  cardNotFound: 'Karte nicht gefunden.',
  mustSelectStyle: 'Bitte Stil wählen',
  mustSelectSize: 'Bitte Größe wählen',
  mustSelectVariant: 'Bitte Variante wählen',
  nameMustHaveCharacters: 'Name muss mindestens ein Zeichen beinhalten.',
  selfService: 'Self-service Sicht nicht gefunden',
  walletNotActivated: 'Etui nicht aktiviert, daher werden zugeordnete Artikel ausgeblendet',
  disabledCard: 'Deaktivierte Karten können nicht genutzt werden',
  contactAndWallet: 'Etui ID und Kontakt können nicht gleichzeitig gewählt werden',
  walletNotEnabled: 'Etui ist nicht aktiv',
  discountError: 'Dieser Rabatt kann nicht gewährt werden',
  noItemReport: 'Für den gewählten Zeitrahmen ist kein Bericht verfügbar',
  timeOut: 'Keine Antwort, bitte Internet Verbindung prüfen',
  mustBeNumber: '***Invoice number must contain only numbers.',
  requiredPassword: 'Kennwort ist ein Pflichtfeld',
  passwordConditions: 'Kennwort muss mehr als 6 und weniger als 35 Zeichen beinhalten',
  matchPasswords: '***Passwords do not match',
  failedPassword: '***Failed to save password',
  invalidKey: '***Invalid activation key',
  failedCompany: '***Failed to fetch company data.',
  nameLess: '***Name must be less than 35 characters',
  requiredEmail: 'Email ist ein Pflichtfeld',
  notValidEmail: 'Email ist ungültig',
  requiredPhone: 'Telefonnr. ist ein Pflichtfeld',
  notValidPhone: 'Telefonnr. ist ungültig',
  enterData: '***Please enter your data.',
  acceptPolicy: '***You must agree with our Terms & Conditions and privacy and cookies policy',
  failedRegistration: '***Failed to register user',
  enterCredentials: '***Please enter your credentials.',
  failedLogin: '***Failed to login',
  failedContactInfo: '***Failed to fetch contact info',
  sessionExpired: '***Session expired. Please log in again.',
  phoneOrEmail: '***You must enter either phone or email',
  failToSend: '***Failed to send request',
  failedCompanyPassword: '***Password reset successfuly, failed to fetch company data.',
  failedAddress: '***Failed to update address info',
  minimalDelivery: 'Mindestbestellsumme für Lieferung',
  commentShorter: '***Comment must be shorter than 1024 characters',
  invalidZip: 'Ungültige PLZ',
  noPostalFound: 'Keine PLZ gefunden für die getätigte Eingabe.',
  oneItem: 'Bitte legen Sie zumindest einen Artikel in den Warenkorb',
  line1: '***You must enter Line 1',
  invalidPostal: 'Die eingegebene PLZ ist ungültig.',
  postalValidate: '***Failed to validate Postal code.',
  codeOutsideArea: 'Die gewählte PLZ liegt außerhalb des Lieferbereiches.',
  failedCalculate: '***Failed to calculate delivery.',
  calculateServer: '***Failed to contact the server for calculating totals. Calculated offline.',
  zipRequired: '***Zip is required',
  countryRequired: '***Country is required',
  countryUnsupported: '***Country not supported',
  totalOver: '***The total must be over',
  thisDelivery: '***for this delivery method',
  validPostal: 'Bitte geben Sie eine gültige PLZ ein.',
  oneItemMinimum: 'Bitte legen Sie mindestens einen Artikel in den Warenkorb.',
  pageNotFound: '***Page not found',
  restaurantClosed: 'Das Restaurant ist im Moment geschlossen.',
  restaurantPreorder: 'Bestellen Sie jetzt vor, das Restaurant öffnet wieder um ',
  restaurantSoon: 'Restaurant schließt in Kürze. Bitte senden Sie die Bestellung so schnell wie möglich ab.',
  restaurantReceiving: '***Restaurant is not receiving orders for today anymore.',
  paymentFailed: '***Payment failed. Redirecting to order summary...',
  malformedPayment: '***Malformed payment query. Redirecting...',
  submitFailed: '***Failed with submitting payment',
  validPostalProvide: '***You must provide a valid postal code.',
  yourSearchFor: '***Your search for',
  foundNo: '***found no results',
  bizzHours: '***Current time is not within our business hours',
  bizzHours2: 'Die gewählte Zeit liegt außerhalb unseren Geschäftszeiten.',
  chosenTime: 'Gewählte Zeit muss später sein als in den nächsten',
  minutes: 'Minuten',
  restaurantClosedToday: 'Das Restaurant ist heute geschlossen',
  choseContact: '***Please choose a contact',
  acceptAgreement: 'Sie müssen den Bedingungen zustimmen um eine Bestellung tätigen zu können',
  addAddress: 'Bitte Adresse wählen',
  enterPhone: 'Bitte Telefonnr. eingeben',
  enterEmail: 'Bitte Email Adresse eingeben',
  enterLastName: 'Bitte Nachname eingeben',
  enterPayment: 'Bitte Zahlungsmethode wählen',
  workingHours: 'Die gewählte Zeit liegt außerhalb der Öffnungszeiten',
  failedOrder: 'Bestellung fehlgeschlagen',
  failedCalculate2: 'Lieferkostenberechnung fehlgeschlagen. Gesamtkosten konnten nicht ermittelt werden.',
  addressAT: 'Bitte Addresse wählen.',
  validPostalOrAddress: 'PLZ und/oder Adresse ist ungültig, bitte um Korrektur',
  requiredName: 'Nachname ist ein Pflichtfeld',
  acceptingOrders: 'Aktuell können wir keine Bestellungen annehmen, bitte versuchen Sie es später.',
  noOrders: 'Keine Bestellungen gefunden.',
};



// WEBPACK FOOTER //
// ./src/lang/de/errors.js